import { TransactionHistoryType } from "redux/actions/actionType";

// header
const initialState = {
  transactionFormData: null,
  transactionPageNum: null,
  transcationSettingOrignal: [
    { id: 1, name: "Logo", checked: true, type: "headerList" },
    { id: 2, name: "Company Name", checked: true, type: "headerList" },
    { id: 3, name: "Company Address", checked: true, type: "headerList" },
    { id: 4, name: "Invoice Name", checked: true, type: "headerList" },
    { id: 5, name: "Remarks", checked: true, type: "footerList" },
    { id: 6, name: "Terms & Condition", checked: true, type: "footerList" },
    { id: 7, name: "Code", checked: true, type: "bodyList" },
    { id: 8, name: "Name", checked: true, type: "bodyList" },
    { id: 9, name: "NRIC", checked: true, type: "bodyList" },
    { id: 10, name: "Cust Refer", checked: true, type: "bodyList" },
    { id: 11, name: "Cust Phone", checked: true, type: "bodyList" },
    { id: 12, name: "Trans", checked: true, type: "bodyList" },
    { id: 13, name: "Date", checked: true, type: "bodyList" },
    { id: 14, name: "Time", checked: true, type: "bodyList" },
    { id: 15, name: "Issued", checked: true, type: "bodyList" },
    { id: 16, name: "Table Sno", checked: true, type: "bodyList" },
    { id: 17, name: "Table Desc", checked: true, type: "bodyList" },
    { id: 18, name: "Table Qty", checked: true, type: "bodyList" },
    { id: 19, name: "Table U/P", checked: true, type: "bodyList" },
    { id: 20, name: "Disc", checked: true, type: "bodyList" },
    { id: 21, name: "N/P", checked: true, type: "bodyList" },
    { id: 22, name: "Paid", checked: true, type: "bodyList" },
    { id: 23, name: "Balance", checked: true, type: "bodyList" },
    { id: 24, name: "Sold By", checked: true, type: "bodyList" },
    { id: 25, name: "Service By", checked: true, type: "bodyList" },
    { id: 26, name: "Sub Total", checked: true, type: "bodyList" },
    { id: 27, name: "GST", checked: true, type: "bodyList" },
    { id: 28, name: "Rounding", checked: true, type: "bodyList" },
    { id: 29, name: "Grand Total", checked: true, type: "bodyList" },
    { id: 31, name: "Outstanding", checked: true, type: "bodyList" },
    { id: 32, name: "Signature", checked: true, type: "footerList" },
    { id: 33, name: "Phone Number", checked: true, type: "headerList" },
    { id: 34, name: "Email", checked: true, type: "headerList" },
    { id: 35, name: "UEN", checked: true, type: "headerList" },
    { id: 36, name: "Gst Registration", checked: true, type: "headerList" },
    { id: 37, name: "Tax Invoice", checked: true, type: "headerList" },
    { id: 38, name: "Redeem Service", checked: true, type: "headerList" },
    { id: 39, name: "TD Slip", checked: true, type: "headerList" },
    { id: 40, name: "Non Sales Invoice", checked: true, type: "headerList" },
    { id: 41, name: "Credit Note", checked: true, type: "headerList" },
    { id: 42, name: "Product Issue Slip", checked: true, type: "headerList" },
    { id: 43, name: "Footer List", checked: true, type: "footerList" },
    { id: 44, name: "SST", checked: true, type: "bodyList" },
  ],
  transactionSettingList: [],
  transactionOrderChangeList: [],
};

export default (state = Object.assign({}, initialState), { type, payload }) => {
  switch (type) {
    case TransactionHistoryType.getTransactionHistory:
      return {
        ...state,
        transactionFormData: payload,
      };

    case TransactionHistoryType.getTransactionPageNum:
      return {
        ...state,
        transactionPageNum: payload,
      };
    case TransactionHistoryType.getTransactionSetting:
      return {
        ...state,
        transactionSettingList: payload,
      };
    case TransactionHistoryType.getTransactionSettingList:
      return {
        ...state,
        transactionSettingList: payload,
      };
    case TransactionHistoryType.getTransactionOrderChange:
      return {
        ...state,
        transactionOrderChangeList: payload,
      };

    default:
      return state;
  }
};
